'use client'
import { getAssetUrl } from '@/constant/assets';
import { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';
import Confetti from 'react-confetti'
import { createPortal } from 'react-dom';

export interface ConfettiComponentRef {
  fire: () => void;
}

interface ConfettiComponentProps {
  initial?: boolean;
}

const ConfettiComponent = forwardRef<ConfettiComponentRef, ConfettiComponentProps>((props, ref) => {
  const { initial = false } = props;
  const [confetti, setConfetti] = useState(initial);
  const [mounted, setMounted] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState({
    width: 0,
    height: 0,
  });
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    setMounted(true);

    function handleResize() {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 向父组件暴露 fire 方法
  useImperativeHandle(ref, () => ({
    fire: () => {
      setConfetti(true);
      audioRef.current = new Audio(getAssetUrl('assets/audio/completed.wav'));
      audioRef.current.volume = 0.3;
      audioRef.current.play();
    }
  }));

  if (!mounted || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999, // 最大安全 z-index
        pointerEvents: 'none', // 防止干扰点击
      }}
    >
    <Confetti
      width={windowDimensions.width}
      height={windowDimensions.height}
      recycle={false}
      numberOfPieces={confetti ? 500 : 0}
      onConfettiComplete={(confetti: any) => {
        setConfetti(false)
        confetti.reset()
        }}
      />
    </div>,
    document.body
  )
});

ConfettiComponent.displayName = "ConfettiComponent";

export default ConfettiComponent;
